import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TBurger } from '@/shared/types/deprecated-types'
import { AnimationDirection } from '@/shared/ui/Animation/Animation'

const initialState: TBurger = {
	isOpen: false,
	activePage: { sectionId: 'main', direction: AnimationDirection.Back }
}

const burger = createSlice({
	name: `burger`,
	initialState,
	reducers: {
		setBurgerOpen: (state, action: PayloadAction<boolean>) => {
			state.isOpen = action.payload
		},
		setActivePage: (state, action: PayloadAction<{ sectionId: string; direction: AnimationDirection }>) => {
			state.activePage = action.payload
		}
	}
})

export const { setBurgerOpen, setActivePage } = burger.actions
export default burger.reducer
